import ApiClient from './ApiClient';

class TelegramPersonalGatewayAPI extends ApiClient {
  constructor() {
    super('telegram_personal_gateway', { accountScoped: true });
  }

  ready() {
    return axios.get(`${this.url}/ready`);
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  qr() {
    return axios.get(`${this.url}/qr`);
  }

  logout() {
    return axios.post(`${this.url}/logout`);
  }

  startHistoryImport() {
    return axios.post(`${this.url}/history_import_start`);
  }

  historyImportStatus() {
    return axios.get(`${this.url}/history_import_status`);
  }

  stopHistoryImport() {
    return axios.post(`${this.url}/history_import_stop`);
  }

  sendOutbound(payload) {
    return axios.post(`${this.url}/outbound_send`, payload);
  }
}

export default new TelegramPersonalGatewayAPI();
